import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ArrowDownIcon } from '@chakra-ui/icons';
import { Box, Heading, Text } from '@chakra-ui/react';
import { getStaticContent, SITE_LEISURE } from '@whitbread-eos/api';
import { Icon } from '@whitbread-eos/atoms';
import { formatAssetsUrl, useCustomLocale, useQueryRequest } from '@whitbread-eos/utils';
import Image from 'next/image';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function HomeBanner(_ref) {
  var _staticContent$header;
  var searchComponent = _ref.searchComponent;
  var _useCustomLocale = useCustomLocale(),
    language = _useCustomLocale.language,
    country = _useCustomLocale.country;
  var query = getStaticContent(false);
  var _useQueryRequest = useQueryRequest(['GetStaticContent', language, country], query, {
      country,
      language,
      site: SITE_LEISURE,
      businessBooker: false
    }),
    staticContent = _useQueryRequest.data;
  var heroData = staticContent === null || staticContent === void 0 || (_staticContent$header = staticContent.headerInformation) === null || _staticContent$header === void 0 || (_staticContent$header = _staticContent$header.content) === null || _staticContent$header === void 0 ? void 0 : _staticContent$header.hero;
  var backgroundImageUrl = (heroData === null || heroData === void 0 ? void 0 : heroData.backgroundImage) || null;
  var textShadow = '0px 2px 12px var(--chakra-colors-darkGrey1)';
  var heroWrapperStyles = {
    mt: {
      base: '-0.5rem'
    },
    pt: 0,
    mb: 0,
    width: '100%',
    position: 'relative',
    overflow: 'visible'
  };
  var homeBannerStyles = {
    wrapper: {
      position: 'relative',
      width: '100vw',
      height: '100%',
      minHeight: {
        base: '480px',
        sm: '380px',
        md: '455px'
      },
      maxHeight: {
        base: 'auto',
        sm: 'auto',
        md: '470px'
      },
      marginLeft: 'calc(-50vw + 50%)',
      overflow: 'visible',
      backgroundColor: heroData !== null && heroData !== void 0 && heroData.backgroundColor ? "#".concat(heroData.backgroundColor) : '#5B2E66',
      backgroundImage: backgroundImageUrl ? undefined : 'linear-gradient(135deg, #5B2E66 0%, #7B4E7E 50%, #9B6E96 100%)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: {
        base: 'space-between'
      },
      pt: {
        base: '0.5rem',
        sm: '2rem',
        md: '2.5rem'
      },
      pb: {
        base: '0.5rem',
        sm: '1.5rem',
        md: '2rem'
      },
      mt: 0
    },
    imageContainer: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: {
        base: 'auto',
        sm: 0
      },
      width: '100%',
      height: {
        base: '183px',
        sm: '100%'
      },
      zIndex: 0,
      overflow: 'hidden'
    },
    innerWrapper: {
      position: 'relative',
      zIndex: 1,
      width: '100%',
      maxW: {
        base: '100%',
        lg: '1340px'
      },
      mx: 'auto',
      px: 0,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: {
        base: 'center',
        sm: 'space-between'
      },
      alignItems: {
        base: 'center',
        sm: 'stretch'
      },
      flex: 1,
      gap: {
        base: 4,
        sm: 0
      }
    },
    contentContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: {
        base: 'center',
        sm: 'flex-start'
      },
      flex: {
        base: 0,
        sm: 1
      },
      pl: {
        base: 4,
        sm: 4,
        md: 6,
        lg: 8
      },
      py: {
        base: '0.5rem',
        sm: '2rem',
        md: '3rem'
      },
      width: {
        base: '100%',
        sm: '75%',
        lg: '60%'
      },
      minHeight: {
        base: '183px',
        sm: 'auto'
      }
    },
    title: {
      color: heroData !== null && heroData !== void 0 && heroData.headingFontColor ? "#".concat(heroData.headingFontColor) : 'white',
      fontSize: {
        base: '1.8125rem',
        sm: '2.25rem',
        lg: '3rem'
      },
      fontWeight: (heroData === null || heroData === void 0 ? void 0 : heroData.headingFontWeight) || '700',
      fontFamily: 'Proxima Nova Sans, sans-serif',
      textAlign: {
        base: 'center',
        sm: 'left'
      },
      textShadow: heroData !== null && heroData !== void 0 && heroData.headingFontShadow ? textShadow : 'none',
      mb: {
        base: 2,
        md: 3
      },
      lineHeight: {
        base: '1.2',
        md: '1.1'
      },
      letterSpacing: '-0.02em'
    },
    subtitle: {
      color: heroData !== null && heroData !== void 0 && heroData.subHeadingFontColor ? "#".concat(heroData.subHeadingFontColor) : 'white',
      fontSize: {
        base: '1rem',
        sm: '1.4375rem',
        lg: '1.8125rem'
      },
      fontWeight: (heroData === null || heroData === void 0 ? void 0 : heroData.subHeadingFontWeight) || '400',
      fontFamily: 'Proxima Nova Sans, sans-serif',
      textAlign: {
        base: 'center',
        sm: 'left'
      },
      textShadow: heroData !== null && heroData !== void 0 && heroData.subHeadingFontShadow ? textShadow : 'none',
      maxWidth: {
        base: '100%',
        md: '1000px'
      },
      lineHeight: '1.2'
    },
    searchWrapper: {
      width: '100%',
      maxWidth: {
        base: '100%',
        lg: 'var(--chakra-space-breakpoint-lg)',
        xl: 'var(--chakra-space-breakpoint-xl)'
      },
      px: {
        base: '1rem',
        sm: '1.25rem',
        md: '1.5rem',
        lg: '1.75rem'
      },
      mx: 'auto',
      mt: {
        base: 0,
        sm: 'auto'
      }
    },
    bottomCaptionWrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      mt: {
        mobile: '-100px',
        xs: '-50px',
        sm: 6
      },
      gap: 2
    },
    bottomCaptionText: {
      color: {
        base: 'black',
        sm: 'white'
      },
      fontSize: {
        base: '0.875rem',
        sm: '1.25rem'
      },
      fontWeight: '550',
      fontFamily: 'Proxima Nova Sans, sans-serif',
      textAlign: 'center',
      lineHeight: '1.5',
      textShadow: {
        base: 'none',
        sm: undefined
      }
    },
    bottomCaptionArrow: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  };
  return _jsx(Box, _objectSpread(_objectSpread({}, heroWrapperStyles), {}, {
    children: _jsxs(Box, _objectSpread(_objectSpread({}, homeBannerStyles.wrapper), {}, {
      "data-testid": "home-banner",
      children: [backgroundImageUrl && _jsx(Box, _objectSpread(_objectSpread({}, homeBannerStyles.imageContainer), {}, {
        children: _jsx(Image, {
          src: formatAssetsUrl(backgroundImageUrl),
          alt: "Home Banner Background",
          fill: true,
          fetchPriority: "high",
          style: {
            objectFit: 'cover',
            objectPosition: 'center'
          },
          "data-testid": "home-banner-image",
          sizes: "100vw"
        })
      })), _jsxs(Box, _objectSpread(_objectSpread({}, homeBannerStyles.innerWrapper), {}, {
        children: [_jsxs(Box, _objectSpread(_objectSpread({}, homeBannerStyles.contentContainer), {}, {
          children: [_jsx(Heading, _objectSpread(_objectSpread({
            as: "h1"
          }, homeBannerStyles.title), {}, {
            "data-testid": "home-banner-title",
            children: (heroData === null || heroData === void 0 ? void 0 : heroData.headingTextShort) || (heroData === null || heroData === void 0 ? void 0 : heroData.headingTextLong)
          })), ((heroData === null || heroData === void 0 ? void 0 : heroData.subHeadingShow) !== false || !heroData) && _jsx(Text, _objectSpread(_objectSpread({}, homeBannerStyles.subtitle), {}, {
            "data-testid": "home-banner-subtitle",
            children: heroData === null || heroData === void 0 ? void 0 : heroData.subHeadingText
          }))]
        })), _jsx(Box, _objectSpread(_objectSpread({}, homeBannerStyles.searchWrapper), {}, {
          mb: heroData !== null && heroData !== void 0 && heroData.bottomCaptionShow ? 0 : 'auto',
          sx: {
            '& *': {
              boxShadow: 'none !important',
              marginBottom: heroData !== null && heroData !== void 0 && heroData.bottomCaptionShow ? 0 : undefined
            }
          },
          "data-testid": "home-banner-searchWrapper",
          children: searchComponent
        })), (heroData === null || heroData === void 0 ? void 0 : heroData.bottomCaptionShow) && _jsxs(Box, _objectSpread(_objectSpread({}, homeBannerStyles.bottomCaptionWrapper), {}, {
          children: [_jsx(Text, _objectSpread(_objectSpread({}, homeBannerStyles.bottomCaptionText), {}, {
            textShadow: {
              base: 'none',
              sm: heroData !== null && heroData !== void 0 && heroData.bottomCaptionShadow ? textShadow : 'none'
            },
            "data-testid": "home-banner-bottomCaptionText",
            children: heroData === null || heroData === void 0 ? void 0 : heroData.bottomCaptionText
          })), (heroData === null || heroData === void 0 ? void 0 : heroData.bottomCaptionArrowShow) && _jsx(Box, _objectSpread(_objectSpread({}, homeBannerStyles.bottomCaptionArrow), {}, {
            "data-testid": "home-banner-bottomCaptionArrow",
            children: _jsx(Icon, {
              color: {
                base: 'black',
                sm: 'white'
              },
              as: ArrowDownIcon,
              boxSize: 5
            })
          }))]
        }))]
      }))]
    }))
  }));
}